export default __webpack_public_path__ + "static/media/sally_graddon.697a7707.jpg";